module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_9.f3117ddb.mp3";